var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"value":_vm.defaultValue,"tabindex":"-1"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("field-label")]},proxy:true}],null,true)},'v-text-field',_vm.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }